export const PROGRAM_KEY_EMAIL_SUBJECT =
  'Your Mentology Classroom Access Key';

export interface ProgramKeyEmailDraft {
  to: string;
  subject: string;
  body: string;
  recipientName: string;
  programKey: string;
}

export function buildProgramKeyEmailBody(recipientName: string, programKey: string): string {
  const name = recipientName.trim() || 'there';

  return `Hi ${name}

Thank you for your interest in the Mentology Mentor Learning Program. Your custom access credentials for the private classroom have been successfully generated and assigned to your account.

YOUR UNIQUE CLASSROOM ACCESS KEY: > ${programKey}

How to activate your classroom:
Go directly to your login portal at: https://learning.mentology.com.au/
Click on the "Classroom Portal" button.
In the next screen - copy and paste your custom access key shown above into the
"Please enter your registration key" and validate.
You will then enter the Introduction page, after the introduction you can click and enter the individual setup page - please complete all field and click to enter your learning Classroom

Should you need assistance setting up your classroom? Contact our support desk at support@mentology.com.au.

Your Administration Team
Mentology
Email: admin@mentology.com.au
Website: https://mentology.com.au/`;
}

export function createProgramKeyEmailDraft(
  recipientName: string,
  recipientEmail: string,
  programKey: string,
): ProgramKeyEmailDraft {
  return {
    to: recipientEmail.trim(),
    subject: PROGRAM_KEY_EMAIL_SUBJECT,
    body: buildProgramKeyEmailBody(recipientName, programKey),
    recipientName: recipientName.trim(),
    programKey: programKey.trim(),
  };
}

export function buildGmailComposeUrl(draft: Pick<ProgramKeyEmailDraft, 'to' | 'subject' | 'body'>): string {
  const params = new URLSearchParams({
    view: 'cm',
    fs: '1',
    to: draft.to,
    su: draft.subject,
    body: draft.body,
  });

  return `https://mail.google.com/mail/?${params.toString()}`;
}

export function openGmailCompose(draft: Pick<ProgramKeyEmailDraft, 'to' | 'subject' | 'body'>): void {
  const url = buildGmailComposeUrl(draft);
  window.open(url, '_blank', 'noopener,noreferrer');
}

export function buildMailtoComposeUrl(draft: Pick<ProgramKeyEmailDraft, 'to' | 'subject' | 'body'>): string {
  const params = new URLSearchParams({
    subject: draft.subject,
    body: draft.body,
  });

  return `mailto:${encodeURIComponent(draft.to)}?${params.toString()}`;
}
